import store from '../store';

export default {
    isDebug(name) {
        // Test if an element name is enabled for debugging

        if (name !== undefined) {
            let conf = store.getters.constants['frontend_config']
            for (const elm in conf) {
                if (conf[elm]['key'] === 'debug') return conf[elm].element[name.toLowerCase()] === true
            }
        }
        return false
    },

    debugLog(debugType, script, element, message) {
        // Show a debug message in JS script

        if (this.isDebug(debugType)) {
            if (debugType !== undefined && script !== undefined && element !== undefined) {
                console.log(`${new Date().toLocaleString()} - DEBUG ${debugType.toUpperCase()} - ${script} --> ${element}`)
                console.log(message)
            }
        }
    }
}
